/* ── Studio Phalsa — Craft Section JS (IntersectionObserver) ── */
(function () {
  'use strict';

  const panels = document.querySelectorAll('.sp-craft__panel');
  if (!panels.length) return;

  const io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  panels.forEach(function (panel) { io.observe(panel); });
})();
